export enum CERTIFICATION_TYPES {
	DRIVING_LICENSE = "DRIVING_LICENSE",
	POLICE_RECORD_EXTRACTS = "POLICE_RECORD_EXTRACTS",
	VOCATIONAL_IDENTIFICATION = "VOCATIONAL_IDENTIFICATION",
}

export enum OTHER_DOCUMENT_TYPES {
	CV = "CV",
	COVER_LETTER = "COVER_LETTER",
	OTHER = "OTHER",
}
